import { render } from "./BlogDetailPage.vue?vue&type=template&id=0469c14a&scoped=true"
import script from "./BlogDetailPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailPage.vue?vue&type=script&lang=js"

import "./BlogDetailPage.vue?vue&type=style&index=0&id=0469c14a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0469c14a"]])

export default __exports__